function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "g1713",
  transform: "translate(4.95 -2.121) rotate(45)"
}, React.createElement("path", {
  id: "path1245",
  d: "M-239.46-110.08h10",
  transform: "translate(239.46 115.08)",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), React.createElement("path", {
  id: "path1709",
  d: "M-151.568-197.971v10",
  transform: "translate(156.568 197.971)",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 9.9,
    height: 9.899,
    viewBox: "0 0 9.9 9.899"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/close.c9ddda35.svg";
export { SvgComponent as ReactComponent };